<template>
  <div>
    <jd-form
      class="mb16"
      :form-info="formSchema"
      @search="search"
      ref="inputFormRef"
    />
    <div style="margin-bottom: 16px" class="flex-between">
      <jd-button type="break" @click="addCrowd">按查询结果生成人群</jd-button>
      <jd-button type="text" @click="exportAll">导出</jd-button>
    </div>
    <div class="new-table-box">
      <jd-table
        :loading="loading"
        :tableData="dataSource"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%"
        :pageInfo="{
          pageNum: formList.current,
          pageSize: formList.size,
          total: formList.total,
        }"
        @handlePage="handleCurrentChangeAll"
      >
        <el-table-column prop="nickname" label="参与用户名称"></el-table-column>
        <el-table-column :prop="chaosParams" :label="`参与用户${searchGrayId}`"></el-table-column>
        <el-table-column
          prop="inviteeNickname"
          label="被邀请用户名称"
        ></el-table-column>
        <el-table-column
          :prop="inviteeChaosParams"
          :label="`被邀请用户${searchGrayId}`"
        ></el-table-column>
        <el-table-column prop="createTime" label="砍价时间"></el-table-column>
        <el-table-column
          prop="bargainValueDesc"
          label="砍价结果"
        ></el-table-column>
        <el-table-column
          prop="inviteeHasParticipatedDesc"
          label="被邀请用户是否参与砍价"
        ></el-table-column>
      </jd-table>
    </div>
    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog.sync="isShowCrowdDialog"
      :condition="condition"
      :activityType="rowData.activityType"
      :source="7"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose"
    />

    <!-- 导出 -->
    <generate
      :control="openRemarkDialog"
      v-if="openRemarkDialog"
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"
    ></generate>
  </div>
</template>

<script>
import crowdDialog from "@/components/crowd-Dialog.vue";
import {
  getBargainRecord,
  bargainRecordExport,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import statisticsData from "@/mixin/activity_statistics_new.js";
export default {
  mixins: [statisticsData],
  components: {
    crowdDialog,
  },
  props: {
    rowData: {
      type: Object,
      default: () => {},
    },
    currentShop: {
      // 当前选择店铺
      type: String,
      default: "",
    },
    sellerLinkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formSchema: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "砍价时间：",
          type: "DateRange",
          dateType: "datetime",
          startTime: "", //进来默认时间但没传值，所以测试叫我去掉默认值
          endTime: "",
          startKey: "createStartTime",
          endKey: "createEndTime",
          defalutLimit: true,
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      formList: {
        size: 10,
        current: 1,
        total: 0,
        activityId: this.rowData.id,
      },
      dataSource: [],
      loading: false,
      searchInfo: {}, // 搜索参数
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: false, // 是否有默认值
      defaultValueText: "", // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗
      condition: {}, // 生成人群条件
    };
  },
  computed: {
    searchGrayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
    grayText() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin（加密）'
    },
    chaosParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'chaosPin'
    },
    inviteeChaosParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'inviteeChaosXid' : 'inviteeChaosPin'
    }
  },
  watch: {
    sellerLinkList: {
      handler(newVal, oldVal) {
        if (newVal.length) {
          const list = newVal.map((item) => {
            return {
              label: item.sellerLinkName,
              value: item.id,
            };
          });
          this.formSchema.some((item) => {
            if (item.prop == "sellerLinkId") {
              item.options = list;
            }
          });
        }
      },
      deep: true,
    },
    searchGrayId: {
      handler(newVal, oldVal) {
        this.formSchema.forEach((item)=>{
          if(item.prop=='pin') {
            item.label = item.label.replace(/pin/ig, newVal)
            item.prop = newVal;
            item.placeholder = item.placeholder.replace(/pin/ig, newVal)
          }
        })
      },
      deep: true,
      immediate: true,
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleCurrentChangeAll(val) {
      console.log(val);
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getList();
    },
    /**
     * 搜索
     * @param params 查询参数
     * @param type 类型 reset 重置  search 搜索
     */
    search(params, type) {
      this.formList.current = 1;
      this.formList[this.searchGrayId] = params[this.searchGrayId] || ""
      this.formList = {
        ...this.formList,
        ...params,
      };
      if (type == "reset") {
        this.searchInfo = {};
        this.formList.size = 10;
        this.formList.current = 1;
        this.getList();
        return;
      }
      this.searchInfo = params;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        const params = {
          ...this.searchInfo,
          ...this.formList,
          activityId: this.rowData.id,
        };
        this.condition = {
          ...params,
          hdSource: 45,
          activityType: this.rowData.activityType,
        };
        console.log(this.condition);

        const res = await getBargainRecord(params);
        let { records = [], total = 0 } = res.data;
        this.dataSource = records;
        this.formList.total = Number(total);
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    /**
     * 生成人群
     */
    addCrowd() {
      this.hasDefaultValue = true;
      this.defaultValueText = "拼团砍价-砍价记录-";
      this.isShowCrowdDialog = true;
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
    /**
     * 导出
     */
    exportAll() {
      this.openRemarkDialog = true;
    },
    /**
     * 确认导出
     * @param exportRemark 备注内容
     */
    confirmExport(exportRemark = "") {
      let obj = this.$refs.inputFormRef.export_fun2();
      let params = {
        ...obj,
        activityId: this.rowData.id,
        current: 1,
        size: 9999999,
        exportRemark,
      };
      this.formLoading = true;
      bargainRecordExport(params).then((res) => {
        this.formLoading = false;
      });
    },
    handleSizeChange(val) {
      this.formList.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
